import React, { useEffect, useRef, useState } from 'react';
// import braintree from 'braintree';

const fields = [
    'cardholderName',
    'cvv',
    'expirationDate',
    'number'
]

const BraintreeStyles = () => (
    <style>
        {`
        .apple-google-buttons-div {
            display: flex; 
            gap: 10px; 
            align-items: center; 
            max-width: 90vw;
            padding-top: 15px;
        }

        .google-button {
            flex: 0 0 50%; 
            height: 56px;
        }

        .apple-pay-button {
            display: inline-block;
            -webkit-appearance: -apple-pay-button;
            -apple-pay-button-type: plain; 
            -apple-pay-button-style: black; 
            width: 240px;
            height: 56px;
            border: none;
            cursor: pointer;
            flex: 0 0 50%;
        }

        #braintree-hosted-field-number {
            height: 48px !important;
            background-color: #fff;
            padding-top: 0.75rem;
            padding-left: 1rem;
            padding-bottom: 0.75rem;
            padding-right: 1rem;
        }

        #card-image {
            right: 10px;
            width: 44px;
            height: 28px;
            background-image: url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/346994/card_sprite.png);
            background-size: 86px 458px;
            background-position: -100px 0;
            background-repeat: no-repeat;
            margin-bottom: 10px;
            margin-top: 10px;
            position: absolute;
            &.visa {
              background-position: 0 -398px;
            }
            &.master-card {
              background-position: 0 -281px;
            }
            &.american-express {
              background-position: 0 -370px;
            }
            &.discover {
              background-position: 0 -163px;
            }
            &.maestro {
              background-position: 0 -251px;
            }
            &.jcb {
              background-position: 0 -221px;
            }
            &.diners-club {
              background-position: 0 -133px;
            }
          }
    `}
    </style>);

const CreditCardCapture = ({
    occasionId,
    siteId,
    cardError,
    onSubmit,
    onChange,
    isCheckingAvailability,
    content,
    guestInfo,
    googleMerchantId,
    environment,
    step }) => {

    var braintree = require('braintree-web');

    const [tAndC, setTAndC] = useState("");
    const [hFields, setHFields] = useState({});
    const [validity, setValidity] = useState({});
    const [isCaptchaValid, setIsCaptchaValid] = useState(false);
    const [isMobilePaymentDone, setIsMobilePaymentDone] = useState(false);

    const captchaRef = useRef(null);
    const onChangeRef = useRef(null);
    const onSubmitRef = useRef(null);

    onChangeRef.current = onChange;
    onSubmitRef.current = onSubmit;

    const isValid = validity.cardholderName?.isValid &&
        validity.cvv?.isValid &&
        validity.expirationDate?.isValid &&
        validity.number?.isValid;

    useEffect(() => {
        if (step !== 6) return;
        getTermsAndConditions();
        Setup();
    }, [step]);

    const getTermsAndConditions = async () => {
        const request = new Request(`/umbraco/Api/Booking/GetRequirements?occasionId=${occasionId}&siteId=${siteId}`);
        var result = await fetch(request);
        if (result.status == 200) {
            var responseJson = await result.json();
            setTAndC(responseJson.cardGuaranteeTermsAndConditions);
        } else {
            console.error('Error getting T and Cs');
        }
    }

    const Setup = async () => {
        let token = "";
        const request = new Request("/umbraco/Api/Braintree/GetClientToken");
        var clientTokenResult = await fetch(request);
        if (clientTokenResult.status == 200) {
            var responseJson = await clientTokenResult.json();
            token = responseJson.clientToken;
            // this.requiresCcg = true;
        } else {
            //  handle braintree initialization error
        }
        
        // Wait for Google Pay to be available (loaded in page head)
        const waitForGooglePay = async (maxWaitTime = 10000) => {
            const startTime = Date.now();
            
            while (Date.now() - startTime < maxWaitTime) {
                if (typeof google !== 'undefined' && google.payments) {
                    console.log('Google Pay API available');
                    return true;
                }
                await new Promise(resolve => setTimeout(resolve, 100));
            }
            
            console.warn('Google Pay API not available after waiting');
            return false;
        };
        
        // Wait for Google Pay, then initialize Braintree
        waitForGooglePay().finally(() => {
            braintree.client.create({
                authorization: token,
            }, clientDidCreate);
        });

    }

    const threeDSecureCreate = (err, client) => {
        braintree.threeDSecure.create({
            client: client,
            version: 2
        }, function (err, threeDSecureInstance) {
            if (err) {
                console.error(err);
                return;
            }
            threeDSecure = threeDSecureInstance;
        });
    }

    const applePaymentCreate = (err, client) => {
        braintree.applePay.create({ client: client }, function (apErr, applePayInstance) {
            if (apErr) {
                console.error('applePay.create error', apErr);
                return;
            }

            if (window.ApplePaySession) {
                console.log("ApplePay Enabled");
                var button = document.getElementById('apple-pay-button');
                button.hidden = false;
                button.style.display = 'inline-block';
            }

            button.addEventListener('click', function (evt) {
                evt.preventDefault();

                var paymentRequest = applePayInstance.createPaymentRequest({
                    total: { label: 'Prezzo', amount: 0 },
                    requiredBillingContactFields: ['postalAddress', 'phone', 'name', 'email'],
                });

                // Create session and wire required callbacks
                var session = new ApplePaySession(3, paymentRequest);

                session.onvalidatemerchant = function (event) {
                    applePayInstance.performValidation({
                        validationURL: event.validationURL,
                        displayName: 'Prezzo'
                    }, function (validationErr, merchantSession) {
                        if (validationErr) {
                            errorMessage.innerHTML = "<span>" + validationErr + "</span>";
                            errorMessage.classList.remove('hidden');
                            console.error('performValidation error', validationErr);
                            session.abort();
                            return;
                        }
                        session.completeMerchantValidation(merchantSession);
                    });
                };

                session.onpaymentauthorized = function (event) {
                    applePayInstance.tokenize({ token: event.payment.token }, function (tokenizeErr, appleResponse) {
                        if (tokenizeErr) {
                            console.error('Apple Pay tokenize error', tokenizeErr);
                            session.completePayment(ApplePaySession.STATUS_FAILURE);
                            isCheckingAvailability = false;
                            setIsMobilePaymentDone(false);
                            return;
                        }

                        onSubmitRef.current(appleResponse.nonce);
                        isCheckingAvailability = true;
                        setIsMobilePaymentDone(true);

                        session.completePayment(ApplePaySession.STATUS_SUCCESS);
                    });
                };

                session.begin();
            });
        });
    }

    const googlePaymentCreate = (err, client) => {
        // Check if Google Pay API is loaded
        if (typeof google === 'undefined' || !google.payments) {
            console.warn('Google Pay API not available');
            return;
        }
        
        braintree.googlePayment.create({
        client: client,
        googlePayVersion: 2,
        googleMerchantId: googleMerchantId
        }, function (gpErr, googlePaymentInstance) {
        if (gpErr) {
            console.error('Braintree googlePayment.create error', gpErr);
            return;
        }

        var paymentsClient = new google.payments.api.PaymentsClient({
            environment: environment 
        });

        paymentsClient.isReadyToPay({
            apiVersion: 2,
            apiVersionMinor: 0,
            allowedPaymentMethods: googlePaymentInstance.createPaymentDataRequest().allowedPaymentMethods,
            existingPaymentMethodRequired: false
        }).then(function (res) {
            if (res.result) {
            var button = paymentsClient.createButton({
                onClick: onGooglePaymentButtonClicked,
                buttonType: 'book',
                buttonColor: 'black',
                buttonBorderType: 'no_border',
                buttonSizeMode: 'fill'
            });
            document.getElementById('gpay-button-container').appendChild(button);
            } else {
            console.info('Google Pay not available on this device/browser.');
            }
        }).catch(function (e) {
            console.error('isReadyToPay error', e);
        });

        function onGooglePaymentButtonClicked() {
            var paymentDataRequest = googlePaymentInstance.createPaymentDataRequest({
            merchantInfo: {
                merchantId: googleMerchantId,
                merchantName: 'Prezzo'
            },
            transactionInfo: {
                currencyCode: 'GBP',
                totalPriceStatus: 'ESTIMATED',
                totalPrice: '0.01',
                totalPriceLabel: 'Card Guarantee (no charge)',
            }
            });

            var cardPaymentMethod = paymentDataRequest.allowedPaymentMethods[0];
            cardPaymentMethod.parameters.billingAddressRequired = true;
            cardPaymentMethod.parameters.billingAddressParameters = {
            format: 'FULL'
            };

            paymentsClient.loadPaymentData(paymentDataRequest)
            .then(function (paymentData) {                
                googlePaymentInstance.parseResponse(paymentData, function (parseErr, result) {
                if (parseErr) {
                    console.error('parseResponse error', parseErr);
                    return;
                }

                onSubmitRef.current(result.nonce);
                isCheckingAvailability = true;
                setIsMobilePaymentDone(true);
                });
            })
            .catch(function (loadErr) {
                // User cancelled or error occurred
                if (loadErr && loadErr.statusCode !== 'CANCELED') {
                console.error('loadPaymentData error', loadErr);
                }
            });
        }
        });
    }

    
    var threeDSecure;

    const clientDidCreate = (err, client) => {
        braintree.hostedFields.create({
            client: client,
            styles: {
                'input': {
                    'font-size': '1.25rem',
                    'line-height': '1.5rem',
                    'color': '#373A36',
                    'height': '48px'
                },
                '.valid': {
                    'color': '#215732'
                },
                '[type="number"]': {
                    'padding-top': '0px',
                    'padding-right': '0px',
                    'padding-bottom': '0px',
                    'padding-left': '0px',
                },
                '.number': {
                    'padding-top': '0px',
                    'padding-right': '0px',
                    'padding-bottom': '0px',
                    'padding-left': '0px',
                }

            },
            fields: {
                cardholderName: {
                    container: '#cardName',
                    placeholder: '',
                    styles: {
                        'font-size': '1.25rem',
                        'padding': '0px'
                    }
                },
                number: {
                    container: '#cardNumber',
                    placeholder: 'xxxx xxxx xxxx xxxx',
                    styles: {
                        'font-size': '1.25rem',
                        'padding': '0px'
                    }
                },
                cvv: {
                    container: '#cardSecurityCode',
                    placeholder: 'xxx',
                    styles: {
                        'font-size': '1.25rem',
                        'padding': '0px'
                    }
                },
                expirationDate: {
                    container: '#cardExpiry',
                    placeholder: 'mm / yy',
                    styles: {
                        'font-size': '1.25rem',
                        'padding': '0px'
                    }
                }
            }
        }, hostedFieldsDidCreate);

        threeDSecureCreate(err, client);
        googlePaymentCreate(err, client);
        applePaymentCreate(err, client);
    }

    const hostedFieldsDidCreate = (err, hostedFields) => {
        setHFields(hostedFields);
        hostedFields.on('cardTypeChange', function (event) {
            // Change card bg depending on card type
            if (event.cards.length === 1) {
                document.getElementById('card-image').className = event.cards[0].type;
            }
        });

        hostedFields.on('validityChange', event => {
            console.log(event.fields);
            setValidity(event.fields);
        });
    }

    const onTokenizeAndSubmit = async () => {
        return new Promise(async (resolve, reject) => {
            if (isMobilePaymentDone) {
                resolve();
            }
            else if (isValid) {
                hFields.tokenize(async (tokenizeErr, payload) => {
                    if (tokenizeErr) {
                        switch (tokenizeErr.code) {
                            case 'HOSTED_FIELDS_FIELDS_EMPTY':
                                // occurs when none of the fields are filled in
                                console.error('All fields are empty! Please fill out the form.');
                                break;
                            case 'HOSTED_FIELDS_FIELDS_INVALID':
                                // occurs when certain fields do not pass client side validation
                                console.error('Some fields are invalid:', tokenizeErr.details.invalidFieldKeys);
                                // you can also programmatically access the field containers for the invalid fields
                                tokenizeErr.details.invalidFields.forEach(function (fieldContainer) {
                                    fieldContainer.className = 'invalid';
                                });
                                break;
                            case 'HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE':
                                // occurs when:
                                //   * the client token used for client authorization was generated
                                //     with a customer ID and the fail on duplicate payment method
                                //     option is set to true
                                //   * the card being tokenized has previously been vaulted (with any customer)
                                // See: https://developer.paypal.com/braintree/docs/reference/request/client-token/generate#options.fail_on_duplicate_payment_method
                                console.error('This payment method already exists in your vault.');
                                break;
                            case 'HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED':
                                // occurs when:
                                //   * the client token used for client authorization was generated
                                //     with a customer ID and the verify card option is set to true
                                //     and you have credit card verification turned on in the Braintree
                                //     control panel
                                //   * the cvv does not pass verification (https://developer.paypal.com/braintree/docs/reference/general/testing#avs-and-cvv/cid-responses)
                                // See: https://developer.paypal.com/braintree/docs/reference/request/client-token/generate#options.verify_card
                                console.error('CVV did not pass verification');
                                break;
                            case 'HOSTED_FIELDS_FAILED_TOKENIZATION':
                                // occurs for any other tokenization error on the server
                                console.error('Tokenization failed server side. Is the card valid?');
                                break;
                            case 'HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR':
                                // occurs when the Braintree gateway cannot be contacted
                                console.error('Network error occurred when tokenizing.');
                                break;
                            default:
                                console.error('Something bad happened!', tokenizeErr);
                        }
                        resolve();
                    } else {
                        await onSubmit(payload.nonce);
                        resolve();
                        setIsCaptchaValid(false);
                    }
                });
            }
            resolve();
        });
    }

    const onloadTurnstileCallback = () => {
        // Check if Turnstile is loaded
        if (typeof window.turnstile === 'undefined') {
            console.warn('Turnstile not loaded yet, retrying...');
            setTimeout(onloadTurnstileCallback, 1500);
            return;
        }
        
        if (captchaRef.current) {
            window.turnstile.render(captchaRef.current, {
                sitekey: process.env.TURNSTILE_SITE_KEY,
                callback: (token) => {
                    setIsCaptchaValid(true);
                    onChangeRef.current('captchaToken', token);
                }
            });
        }
    };

    useEffect(() => {
        if (step !== 6) return;
        if (!isCaptchaValid) onloadTurnstileCallback();
    }, [isCaptchaValid, step]);


    return (
        <div className="my-md">
            <BraintreeStyles />
            <div className='grid md:grid-cols-2 lg:grid-cols-10 gap-6'>
                <div className='flex flex-col gap-4 lg:col-span-5'>

                    <div className="apple-google-buttons-div" style={!isCaptchaValid ? { opacity: 0.4, pointerEvents: 'none' } : {}}>
                        <div id="gpay-button-container" className="google-button"></div>
                        <button type="button" id="apple-pay-button" className="apple-pay-button apple-pay-button-black" style={{ display: 'none' }} hidden></button>
                    </div>

                    <h3 className="text-2xl">Or Enter Card Details Below</h3>

                    <div className="flex flex-col gap-4">
                        <div>
                            <label className="label">Cardholder name</label>
                            <div className="input" id="cardName"></div>
                            {validity.cardholderName?.isValid === false &&
                                <p className="text-tomato mt-3 text-sm mb-0">Please enter a valid card holder name</p>}
                        </div>
                        <div>
                            <label className="label">Card number</label>
                            <div className="input p-0 flex-1" id="cardNumber" style={{ position: 'relative' }}>
                                <div id="card-image" className=""></div>
                            </div>
                            {validity.number?.isValid === false &&
                                <p className="text-tomato mt-3 text-sm mb-0">Please enter a valid card number</p>}
                        </div>
                        <div className="flex w-full gap-4">
                            <div className="flex-1">
                                <label className="label">Card Expiry Date</label>
                                <div className="input" id="cardExpiry" placeholder="MM/YY"></div>
                                {validity.expirationDate?.isValid === false &&
                                    <p className="text-tomato mt-3 text-sm mb-0">Required</p>
                                }
                            </div>
                            <div className="flex-1">
                                <label className="label">Card Security Code</label>
                                <div className="input" id="cardSecurityCode"></div>
                                {validity.cvv?.isValid === false &&
                                    <p className="text-tomato mt-3 text-sm mb-0">Required</p>
                                }
                            </div>
                        </div>
                    </div>

                    <div className="pt-6 flex">
                        <a href={"https://www.braintreegateway.com/merchants/" + process.env.BRAINTREE_MERCHANT_ID + "/verified"} target="_blank">
                            <img src="https://s3.amazonaws.com/braintree-badges/braintree-badge-light.png" width="164px" height="44px" border="0" />
                        </a>
                    </div>

                </div>
                {content && <div className='flex flex-col gap-4 lg:col-span-5'>
                    {content && <div dangerouslySetInnerHTML={{ __html: content }} />}
                </div>}
                <div className='flex flex-col gap-4 lg:col-span-5'>
                    <div className="w-full" ref={captchaRef} data-sitekey={process.env.TURNSTILE_SITE_KEY}></div>
                    <div className="pt-6">
                        {isCaptchaValid &&
                            <button type="button" className='button button-secondary button-lg h-[56px]' disabled={(isCheckingAvailability || !isValid) && !isMobilePaymentDone} onClick={() => {
                                onTokenizeAndSubmit();
                            }}>
                                <div className='flex flex-[1-1-100%] gap-2 text-center justify-center'>
                                    <div>Complete Booking</div>
                                    {isCheckingAvailability &&
                                        <div className='box-icon flex flex-col justify-center'>
                                            <div className="loader-small"></div>
                                        </div>
                                    }
                                </div>
                            </button>}
                        {/*<div className="pt-6">*/}
                        {/*    <p>{tAndC}</p>*/}
                        {/*</div>*/}
                    </div>
                    {cardError && <div>
                        <p className="text-tomato mt-3 text-sm mb-0">There was a problem processing your card details. Please confirm they are correct and try again, or contact the restaurant.</p>
                    </div>}
                </div>

            </div>
        </div>);

}

export default CreditCardCapture;